export interface Hort360Grower {
  id: number;
  abn: string | null;
  company: string | null;
  owner: string | null;
  phone: string | null;
  mobile: string | null;
  emailaddress: string | null;
  canaccess: boolean;
  freshcare: string | null;
  properties: Hort360Property[];
  demo: boolean;
  hash: string;
}
export interface Hort360Property {
  id: number;
  type: number;
  name: string;
  address1: string;
  address2: string;
  suburb: string;
  postcode: string;
  state: number;
  catchment: number;
  reportingcatchment: number;

  area: string;
  irrigation: string;
  active: boolean;
  lotplans: string;
  crops: Hort360PropertyCrop[];
  chemicals: string;
  reefCertDate: string;


}

export interface Hort360PropertyCrop {

      id: number | null,
      name: string,
      group: string | null,
      category: string | null,
      area: number | null

}

export interface Hort360GrowerProperty extends Hort360Grower, Hort360Property {
  propertyId: number;
  growerId: number;
  // This is a bit of a design floor? To reconsider
  propertyName: string;
  growerName: string;
  managerOnly: boolean;
}

// Summary saved to Hort360 for display purposes
export class Hort360PropertySummary {
  id: number | string = 0;
  growerId: number = 0;
  growerDescription: string | null = null;
  type: number = 0; // 1 Management v.s. 0 Property
  area: string | null = null;

  name: string | null = null;
  role: string | null = null;
  address: string | null = null;
  catchment: string | null = null;
  lga: string | null = null;
  propertyCrops: Hort360PropertyCrop[] | null = null;

  managerOnly: boolean = false;
  // active: boolean = true;

  constructor(growerProperty: Hort360GrowerProperty, definitions: Hort360DefinitionWrapper) {
    this.id = growerProperty.propertyId;
    this.type = growerProperty.type;
    this.growerId = growerProperty.growerId;
    this.growerDescription = growerProperty.growerName;
    this.propertyCrops = growerProperty.crops;
    this.name = growerProperty.propertyName;
    this.area = growerProperty.area;

    const catchment = definitions.getCatchment(growerProperty.catchment);
    this.catchment = catchment ? catchment.name : null;

    const state = definitions.getState(growerProperty.catchment);
    this.address = [
      ...growerProperty.address1.split(','),
      ...growerProperty.address2.split(','),
      growerProperty.suburb,
      this.catchment,
      state ? state.name : null,
      growerProperty.postcode,
    ].map(a => (a ? (a + '') : '').trim()).filter(a => !!a).join(',\n');

  }
}

export interface Hort360Definitions {
  catchments: Hort360DefinitionCatchment[];
  chemicals: Hort36DefinitionChemical[];
  crops: Hort360DefinitionCrop[];
  reportingCatchments: Hort360DefinitionReportingCatchment[];
  states: Hort360DefinitionStates[];
}
export interface Hort360DefinitionCatchment {
  id: number;
  name: string;
  groupname: string
  state: number;
}
export interface Hort36DefinitionChemical {
  id: number;
  name: string;
}
export interface Hort360DefinitionCrop {
  id: number;
  name: string;
}
export interface Hort360DefinitionReportingCatchment {
  id: number;
  name: string;
  groupname: string;
  state: number;
}
export interface Hort360DefinitionStates {
  id: number;
  name: string;
}
export class Hort360DefinitionWrapper implements Hort360Definitions {
  catchments: Hort360DefinitionCatchment[];
  chemicals: Hort36DefinitionChemical[];
  crops: Hort360DefinitionCrop[];
  reportingCatchments: Hort360DefinitionReportingCatchment[];
  states: Hort360DefinitionStates[];

  constructor(definitions: Hort360Definitions) {
    this.catchments = definitions.catchments;
    this.chemicals = definitions.chemicals;
    this.crops = definitions.crops;
    this.reportingCatchments = definitions.reportingCatchments;
    this.states = definitions.states;
  }

  getValueFor(key: string, id: number | null,): any | null {
    if ((this as any)[key]) {
      const value = (this as any)[key].find((v: any) => v && v.id && v.id === id);
      if (value) {
        return value;
      }
    }
    return null;
  }
  getCatchment(id: number | null): Hort360DefinitionCatchment {
    return this.getValueFor('catchments', id);
  }
  getChemical(id: number | null): Hort360DefinitionCatchment {
    return this.getValueFor('chemicals', id);
  }
  getCrop(id: number | null): Hort36DefinitionChemical {
    return this.getValueFor('crops', id);
  }
  getReportingCatchment(id: number | null): Hort360DefinitionCrop {
    return this.getValueFor('reportingCatchments', id);
  }
  getState(id: number | null): Hort360DefinitionReportingCatchment {
    return this.getValueFor('states', id);
  }

}






export interface Hort360User {
  id: number;
  grower: number;
  token: string;
}

export interface Hort360Account {
  active: boolean;
  demo: boolean;
  emailaddress: string;
  firstname: string;
  grower: number;
  id: number;
  secondname: string;
  tokenhash: string;
  username: string;
}

export interface Hort360AccountUser extends Hort360Account, Hort360User { }

export enum ContactTypes {
  PHONE = 'phone',
  EMAIL = 'email',
  VISIT = 'visit',
  OTHER = 'other',
}

export interface KnownUserType {
  key: string;
  uid: string;
  level: string;
  email: string;
  name: string;
}

export interface ExtensionCategory {
  id: string;
  icon: string;
  name: string;
  color: string;
  archived?: boolean;
}

export interface ExtensionEvent {
  id: string;
  category: string; // ExtensionCategory.id
  name: string;
  notes: string;
  date: number;
  properties: number; // # props
  attendees: number;  // # attendees (prop > head count)
  user: string; // KnownUserType.uid
  locationTown: string;
  locationLga: string;
  totalAttendees:number;
}

export interface ExtensionActivityType {
  id: string;
  name: string;
  category: string; // ExtensionCategory.id
  archived?: boolean;
}

export interface ExtensionActivity {
  id: string;
  property: string;
  user: string; // KnownUserType.uid
  type: ContactTypes;
  date: number | Date;
  notes: string;
  activities: {[key: string]: number}; // ExtensionActivityType
  flagged: boolean;

  // Practice change events;
  pcWater: {[key: string]: number};
  pcFertiliser: {[key: string]: number};
  pcPesticide: {[key: string]: number};
  pcSoil: {[key: string]: number};
}

export interface AssistanceProvidedType {
  id: string;
  name: string;
  category: string;
}

export interface RiskAddressedType {
  id: string;
  name: string;
  category: string;
}

export interface ActionPlanType {
  id: string;
  name: string;
}

export interface AdditionalSupportType {
  id: string;
  name: string;
}

export interface LgaType {
  id: string;
  name: string;
  type: string;
}

export interface LocalDefinitions {
  actionPlans: ActionPlanType[];
  additionalSupport: AdditionalSupportType[];
  lga: LgaType[];
}

export interface AssistanceProvided {
  id: string;
  user: string;
  property: string;
  type: string; //AssistanceProvidedType.id
  date: number | Date;
  flagged: boolean;
  riskAddressed: string; //RiskAddressedType.id
  planActivity: string;
  learntNewSkills: boolean;
  intentToChange: boolean;
  practiceChange: boolean;
  grantAppliedFor: boolean;
  grantAppliedForName: string;
  referralForAdditionalSupport: string; //AdditionalSupportType.id
  notes: string;
  activities: {[key: string]: number};
}

export interface Meeting {
  id: string;
  date: number;
  topic: string;
  locationTown: string;
  locationLga: string;
  notes: string;
  attendees: number;
  properties: number;
  user: string;
}

export interface PracticeChangeActivity {
  id: string;
  name: string;
  category: string;
}

export interface PracticeChange {
  id: string;
  user: string;
  property: string;
  date: number | Date;
  notes: string;
  activity: string;
}

